/* eslint-disable no-restricted-globals */
import { useMemo } from 'react';

import CountyService from '../../services/CountyService';
import useForm from '../utils/useForm';
import { US_STATES } from '../../constants/formOptions';

const useVendorForm = (onSubmit, values) => {
  const fields = useMemo(
    () => [
      {
        title: 'Vendor',
        fields: [
          {
            title: 'Vendor Name',
            name: 'name',
            type: 'text',
            required: true,
          },
          {
            title: 'Type',
            name: 'type',
            type: 'select',
            required: true,
            options: [
              {
                value: 'HOA',
                label: 'HOA',
              },
              {
                value: 'Tax',
                label: 'Tax',
              },
              {
                value: 'Insurance',
                label: 'Insurance',
              },
              {
                value: 'Other',
                label: 'Other',
              },
              {
                value: 'Lien holder',
                label: 'Lien holder',
              },
            ],
          },
          {
            title: 'Agency Number',
            name: 'agency_number',
            type: 'text',
          },
          {
            title: 'Address Line 1',
            name: 'address_line_1',
            type: 'text',
          },
          {
            title: 'Address Line 2',
            name: 'address_line_2',
            type: 'text',
          },
          {
            title: 'City',
            name: 'city',
            type: 'text',
          },
          {
            title: 'State',
            name: 'state',
            type: 'select',
            options: US_STATES,
          },
          {
            title: 'ZIP',
            name: 'zip',
            type: 'text',
            validation: 'zip',
          },
          {
            title: 'Overnight Name',
            name: 'overnight_name',
            type: 'text',
          },
          {
            title: 'Overnight Attn',
            name: 'overnight_attn',
            type: 'text',
          },
          {
            title: 'Overnight PO Box',
            name: 'overnight_po_box',
            type: 'text',
          },
          {
            title: 'Overnight Address Line 1',
            name: 'overnight_address_line_1',
            type: 'text',
          },
          {
            title: 'Overnight Address Line 2',
            name: 'overnight_address_line_2',
            type: 'text',
          },
          {
            title: 'Overnight City',
            name: 'overnight_city',
            type: 'text',
          },
          {
            title: 'Overnight State',
            name: 'overnight_state',
            type: 'select',
            options: US_STATES,
          },
          {
            title: 'Overnight Zip',
            name: 'overnight_zip',
            type: 'text',
            validation: 'zip',
          },
          {
            title: 'Phone',
            name: 'phone',
            type: 'text',
            validation: 'phone',
            mask: '(999) 999-9999',
          },
          {
            title: 'Website',
            name: 'website',
            type: 'text',
          },
          {
            title: 'County',
            name: 'county_id',
            type: 'fetchableSelect',
            fetchOptions: {
              key: ['counties'],
              queryFn: CountyService.getCounties,
              labelKey: 'name',
            },
          },
          {
            title: 'Email',
            name: 'email',
            type: 'text',
            validation: 'email',
          },
          {
            title: 'Quickbooks ID',
            name: 'qb_vendor_id',
            type: 'text',
          },
        ],
      },
    ],
    []
  );

  const { formik } = useForm({ fields, onSubmit, values });

  return { formik, fields, values };
};

export default useVendorForm;
